import
  React
from 'react';

import
  styled
from 'styled-components';

import
  PropTypes
from 'prop-types';

import {
  Text,
  VContainerVH
} from '@vodacom/web-common';

import {
  CustomColors
} from '../../constants';

const Container = styled(VContainerVH)`
  border-bottom: ${props => props.borderBottom};
  cursor: pointer;
  margin: ${props => props.margin}
`;

export const Tab = (props) => {

  const color = (props.active && props.activeColor) || props.inactiveColor;

  const onTabClick = () => {

    props?.onTabClicked?.({
      id: props.id,
      name: props.name,
      value: props.value,
      label: props.label
    });
  };

  return (

    <Container
      id={props.id}
      automationId={props.automationId}
      onClick={onTabClick}
      color={color}
      active={props.active}
      padding={props.padding}
      margin={props.margin}
      position={props.position}
      bottom={props.bottom}>

      <Container
        borderBottom={props.borderBottom}>

        <Text
          color={color}
          padding={props.textPadding}
          fontSize={props.fontSize}
          fontWeight={props.active ? 'bold' : 'normal'}>

          {props.label}

        </Text>
      </Container>
    </Container>
  );
};

Tab.propTypes = {
  automationId: PropTypes.string.isRequired,
  name: PropTypes.string,
  value: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  label: PropTypes.string,
  active: PropTypes.bool,
  onTabClicked: PropTypes.func,
  textPadding: PropTypes.string,
  inactiveColor: PropTypes.string,
  activeColor: PropTypes.string,
  borderBottom: PropTypes.string,
  margin: PropTypes.string,
  position: PropTypes.string,
  bottom: PropTypes.string
};

Tab.defaultProps = {
  id: 'unknown-tab',
  automationId: 'unknown-tab',
  name: null,
  value: '',
  label: '',
  active: false,
  onTabClicked: () => {},
  textPadding: '0 0 16px 0',
  inactiveColor: CustomColors.Grey9,
  activeColor: CustomColors.Red1,
  borderBottom: `solid 3px ${CustomColors.Transparent}`,
  margin: '0 21px 0 0',
  position: null,
  bottom: null
};
